module.exports = __webpack_public_path__ + "img/coin.297df81.svg";